// extracted by mini-css-extract-plugin
module.exports = {"container":"GerRow_container__A9eHG","col":"GerRow_col__2JA6Q","name":"GerRow_name__2B1jH","amount":"GerRow_amount__34Env"};